<template>
  <div v-if="isReady" class="content animate-panel" id="home">
    <top-banner :images="topBanner" />

      <!-- 1. 本日の販売状況 -->
      <section class="home-card">
        <div class="section-header-row">
          <div class="section-heading">
            <i class="fa fa-bar-chart home-section-icon"></i>
            <span class="section-title">本日の販売状況</span>
            <span class="section-date">{{ todayLabel }}</span>
          </div>
          <button class="section-link-btn" @click="handleClickViewAnalysis()">詳しく分析する <i class="fa fa-angle-right"></i></button>
        </div>
        <div v-if="amountsData.length > 0" class="sales-grid">
          <div class="metric">
            <div class="metric-top">
              <div class="metric-ico"><i class="fa fa-jpy"></i></div>
              <div>
                <div class="metric-label">本日の売上金額</div>
                <div class="metric-value">{{ formatNumber(amountsData[0].value) }}<span class="metric-unit">{{ amountsData[0].unit }}</span></div>
              </div>
            </div>
            <div class="metric-note">
              <span v-if="amountsRate !== null" :class="amountsRate >= 0 ? 'note-up' : 'note-down'">
                <i :class="amountsRate >= 0 ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                {{ amountsRate >= 0 ? '+' : '' }}{{ amountsRate }}%
              </span>
              <span v-else class="note-neutral">―</span>
              （前日 {{ formatNumber(amountsData[1] ? amountsData[1].value : 0) }}{{ amountsData[0].unit }}）
            </div>
          </div>
          <div class="metric">
            <div class="metric-top">
              <div class="metric-ico"><i class="fa fa-line-chart"></i></div>
              <div>
                <div class="metric-label">本日の注文件数</div>
                <div class="metric-value">{{ formatNumber(ordersData[0].value) }}<span class="metric-unit">{{ ordersData[0].unit }}</span></div>
              </div>
            </div>
            <div class="metric-note">
              <span v-if="ordersRate !== null" :class="ordersRate >= 0 ? 'note-up' : 'note-down'">
                <i :class="ordersRate >= 0 ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                {{ ordersRate >= 0 ? '+' : '' }}{{ ordersRate }}%
              </span>
              <span v-else class="note-neutral">―</span>
              （前日 {{ formatNumber(ordersData[1] ? ordersData[1].value : 0) }}{{ ordersData[0].unit }}）
            </div>
          </div>
          <div class="metric">
            <div class="metric-top">
              <div class="metric-ico"><i class="fa fa-shopping-cart"></i></div>
              <div>
                <div class="metric-label">本日の販売個数</div>
                <div class="metric-value">{{ formatNumber(salesData[0].value) }}<span class="metric-unit">{{ salesData[0].unit }}</span></div>
              </div>
            </div>
            <div class="metric-note">
              <span v-if="salesRate !== null" :class="salesRate >= 0 ? 'note-up' : 'note-down'">
                <i :class="salesRate >= 0 ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                {{ salesRate >= 0 ? '+' : '' }}{{ salesRate }}%
              </span>
              <span v-else class="note-neutral">―</span>
              （前日 {{ formatNumber(salesData[1] ? salesData[1].value : 0) }}{{ salesData[0].unit }}）
            </div>
          </div>
          <div class="metric">
            <div class="metric-top">
              <div class="metric-ico"><i class="fa fa-reply"></i></div>
              <div>
                <div class="metric-label">本日の返品個数</div>
                <div class="metric-value">{{ formatNumber(returnsData.length > 0 ? returnsData[0].value : 0) }}<span class="metric-unit">{{ returnsData.length > 0 ? returnsData[0].unit : '個' }}</span></div>
              </div>
            </div>
            <div v-if="returnsData.length > 0" class="metric-note">
              <span v-if="returnsRate !== null" :class="returnsRate <= 0 ? 'note-up' : 'note-down'">
                <i :class="returnsRate >= 0 ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                {{ returnsRate >= 0 ? '+' : '' }}{{ returnsRate }}%
              </span>
              <span v-else class="note-neutral">―</span>
              （前日 {{ formatNumber(returnsData[1] ? returnsData[1].value : 0) }}{{ returnsData[0].unit }}）
            </div>
          </div>
          <div class="sales-chart">
            <kpi-sparkline
              :data="amountsData"
              :orders-data="ordersData"
              :sales-data="salesData"
              :returns-data="returnsData"
            />
          </div>
        </div>
        <div v-else class="text-center"><i class="fa fa-spinner fa-spin"></i></div>
      </section>

      <!-- 2. セルモンエージェントからのおすすめ -->
      <section class="home-card">
        <div class="section-header-row">
          <div class="section-heading-block">
            <div class="section-title">
              <img class="section-logo" src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png" alt="セルモンエージェント">
              セルモンエージェントからのおすすめ
              <button v-if="isBasicPlan || isPremiumTrial" class="btn btn-premium-cta" @click="$router.push('/setting/plan-info')">
                <i class="fa fa-diamond"></i> プレミアムに登録する <i class="fa fa-chevron-circle-right"></i>
              </button>
            </div>
            <div class="section-subtitle">あなたのデータから、今やるべきアクションを見つけました。</div>
          </div>
          <button class="section-link-btn" @click="$router.push('/salemon-agent')">エージェント画面を開く <i class="fa fa-angle-right"></i></button>
        </div>

        <div class="agent-grid">
          <article v-if="userInfo.hasReturnRecommend" class="agent-card agent-card--red">
            <div class="agent-top"><span class="agent-tag agent-tag--red">FBA長期在庫</span></div>
            <div class="agent-head">
              <div class="agent-icon"><i class="fa fa-exclamation-triangle"></i></div>
              <div>
                <p class="agent-title">FBAで無駄な手数料が<br>発生しています</p>
                <div class="agent-value">{{ formatNumber(userInfo.totalFbaFee) }}<span class="agent-unit">円</span></div>
              </div>
            </div>
            <button class="agent-btn agent-btn--red" @click="$router.push('/salemon-agent/long-term-stock')">対象商品を確認する <i class="fa fa-angle-right"></i></button>
          </article>
          <template v-if="!isBasicPlan && !isPremiumTrial">
            <article v-if="userInfo.countFbaProductSales > 0" class="agent-card agent-card--green">
              <div class="agent-top"><span class="agent-tag agent-tag--green">FBA納品推奨</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-truck"></i></div>
                <div>
                  <p class="agent-title">商品を納品して、<br>適切な在庫レベルを維持しましょう</p>
                  <div class="agent-value">{{ formatNumber(userInfo.countFbaProductSales) }}<span class="agent-unit">件</span></div>
                </div>
              </div>
              <button class="agent-btn agent-btn--green" @click="$router.push('/salemon-agent/fba-product-sales')">対象商品を確認する <i class="fa fa-angle-right"></i></button>
            </article>
            <article v-if="userInfo.countSalemonRecommend > 0" class="agent-card agent-card--purple">
              <div class="agent-top"><span class="agent-tag agent-tag--purple">販売機会拡大</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-line-chart"></i></div>
                <div>
                  <p class="agent-title">販売機会を逃している商品が<br>あります</p>
                  <div class="agent-value">{{ formatNumber(userInfo.countSalemonRecommend) }}<span class="agent-unit">件</span></div>
                </div>
              </div>
              <button class="agent-btn agent-btn--purple" @click="$router.push('/salemon-agent/sales-expansion')">対象商品を確認する <i class="fa fa-angle-right"></i></button>
            </article>
            <article v-if="userInfo.countSelmonProductsAvailable > 0" class="agent-card agent-card--blue">
              <div class="agent-top"><span class="agent-tag agent-tag--blue">セルモンへの出品</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-plus-circle"></i></div>
                <div>
                  <p class="agent-title">今すぐ出品できる商品が<br>あります</p>
                  <div class="agent-value">{{ formatNumber(userInfo.countSelmonProductsAvailable) }}<span class="agent-unit">件</span></div>
                </div>
              </div>
              <button class="agent-btn agent-btn--blue" @click="$router.push('/salemon-agent/product-available')">対象商品を確認する <i class="fa fa-angle-right"></i></button>
            </article>
          </template>
          <template v-else-if="isBasicPlan">
            <article class="agent-card agent-card--green">
              <div class="agent-top"><span class="agent-tag agent-tag--green">FBA納品推奨</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-truck"></i></div>
                <p class="agent-title">売れ行きを予測し、適切なFBA納品数をご提案します！</p>
              </div>
              <span class="agent-premium-badge"><i class="fa fa-lock"></i> プレミアム限定</span>
            </article>
            <article class="agent-card agent-card--purple">
              <div class="agent-top"><span class="agent-tag agent-tag--purple">販売機会拡大</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-line-chart"></i></div>
                <p class="agent-title">見逃しているかもしれない販売機会についてお知らせします！</p>
              </div>
              <span class="agent-premium-badge"><i class="fa fa-lock"></i> プレミアム限定</span>
            </article>
            <article class="agent-card agent-card--blue">
              <div class="agent-top"><span class="agent-tag agent-tag--blue">セルモンへの出品</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-plus-circle"></i></div>
                <p class="agent-title">売上アップにつながる商品をお知らせ ワンクリックで出品！</p>
              </div>
              <span class="agent-premium-badge"><i class="fa fa-lock"></i> プレミアム限定</span>
            </article>
          </template>
          <template v-else>
            <article class="agent-card agent-card--green">
              <div class="agent-top"><span class="agent-tag agent-tag--green">FBA納品推奨</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-truck"></i></div>
                <p class="agent-title">売れ行きを予測し、適切なFBA納品数をご提案します!</p>
              </div>
              <p class="agent-caption">※こちらの機能はプレミアムプラン専用となります。</p>
            </article>
            <article class="agent-card agent-card--purple">
              <div class="agent-top"><span class="agent-tag agent-tag--purple">販売機会拡大</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-line-chart"></i></div>
                <p class="agent-title">見逃しているかもしれない販売機会についてお知らせします！</p>
              </div>
              <p class="agent-caption">※こちらの機能はプレミアムプラン専用となります。</p>
            </article>
            <article class="agent-card agent-card--blue">
              <div class="agent-top"><span class="agent-tag agent-tag--blue">セルモンへの出品</span></div>
              <div class="agent-head">
                <div class="agent-icon"><i class="fa fa-plus-circle"></i></div>
                <p class="agent-title">売上アップにつながる商品をお知らせ <i class="fa fa-envelope-o" aria-hidden="true"></i> ワンクリックで出品！</p>
              </div>
              <p class="agent-caption">※こちらの機能はプレミアムプラン専用となります。</p>
            </article>
          </template>
        </div>
      </section>

      <!-- 3. ご利用状況 -->
      <section class="home-card" v-if="warehousesData">
        <div class="section-header-row">
          <div class="section-heading"><span class="section-title"><img class="section-logo section-logo--sm" src="https://salemonster.info/static/dists/img/ic_SaleMonster24.png" alt="セールモンスター"> ご利用状況</span></div>
          <button class="section-link-btn" @click="handleClickJoinPremium()">プラン・設定を確認する <i class="fa fa-angle-right"></i></button>
        </div>
        <div class="usage-grid">
          <div class="usage-block">
            <div class="usage-label">ご利用プラン</div>
            <div :class="['usage-value', isBasicPlan ? '' : 'usage-premium']">
              {{ plan }}
              <span v-if="isPremiumTrial" class="text-size-14">(トライアル)</span>
            </div>
            <div>
              <button v-if="isBasicPlan || isPremiumTrial" class="btn btn-premium-cta" @click="$router.push('/setting/plan-info')">
                <i class="fa fa-diamond"></i> プレミアムに登録する <i class="fa fa-chevron-circle-right"></i>
              </button>
            </div>
          </div>
          <div class="usage-block">
            <div class="usage-label">登録商品数 / 出品可能数</div>
            <div class="usage-inline">
              <strong class="usage-inline-num">{{ formatNumber(warehousesData.offerCount) }}</strong><span>件</span>
              <span class="usage-inline-sep">/</span>
              <strong class="usage-inline-num usage-inline-num--sub">{{ formatNumber(warehousesData.maxListingAmount) }}</strong><span>件</span>
            </div>
            <div class="usage-bar"><div class="usage-bar-fill" :style="{ width: listingUsageRatio + '%' }"></div></div>
            <a class="usage-link" @click.stop="handleClickAddAvailableQuantity()">出品可能数を追加する <i class="fa fa-angle-right"></i></a>
          </div>
          <div class="usage-block">
            <div class="usage-label">審査状況</div>
            <div class="usage-status-row">
              <span>審査中 <strong class="usage-status">{{ warehousesData.review }}</strong>件</span>
              <span>出品中 <strong class="usage-status usage-active">{{ warehousesData.sale }}</strong>件</span>
              <span>審査NG <strong class="usage-status usage-ng">{{ warehousesData.reject }}</strong>件</span>
            </div>
            <a class="usage-link" @click.stop="handleClickRequestReconsideration()">審査状況を確認する <i class="fa fa-angle-right"></i></a>
          </div>
          <div class="usage-block usage-block--logi">
            <div class="usage-block-head">
              <img src="https://image-yoshino.sakura.ne.jp/monster/SaleMonLogi.png" class="w-30">
              セルモンロジ
            </div>
            <div class="usage-divider"></div>
            <div class="usage-stockcrew">
              <img class="stockcrew-logo" :src="iconUrls['salmonSc']" alt="STOCKCREW">
              <div>
                <div class="usage-label">STOCKCREW倉庫</div>
                <div :class="['usage-value', warehouseScUsed ? 'usage-active' : 'usage-inactive']">
                  {{ warehouseScUsed ? '利用中' : '未利用' }}
                </div>
              </div>
            </div>
            <a v-if="warehouseScUsed" class="usage-link" @click.stop="handleClickOpenWarehouse('salmonSc')">STOCKCREW倉庫を開く <i class="fa fa-angle-right"></i></a>
            <a v-else class="usage-link" @click.stop="handleClickGetStarted('salmonSc')">利用を開始する <i class="fa fa-angle-right"></i></a>
          </div>
        </div>
      </section>
      <section class="home-card" v-else>
        <div class="section-heading"><span class="section-title">ご利用状況</span></div>
        <div class="text-center" style="padding:20px 0"><i class="fa fa-spinner fa-spin"></i></div>
      </section>

    <!-- 4. お知らせ / イベント情報 / マニュアル -->
    <div class="info-grid">
      <section class="home-card info-card">
        <div class="section-header-row">
          <div class="section-heading"><i class="fa fa-bell-o home-section-icon"></i><span class="section-title">お知らせ</span></div>
        </div>
        <div v-if="notices.length > 0" class="info-list">
          <div v-for="(notice, i) in notices.slice(0, 5)" :key="i" class="info-item" @click="handleViewNotice(notice)">
            <span class="info-date">{{ notice.date }}</span>
            <span class="info-link" v-html="replaceHTMLSellerInfo(notice.title)"></span>
          </div>
        </div>
        <div v-else-if="notices.length === 0" class="info-empty">現在お知らせはありません</div>
      </section>

      <section class="home-card info-card">
        <div class="section-header-row">
          <div class="section-heading"><i class="fa fa-calendar-o home-section-icon"></i><span class="section-title">イベント情報</span></div>
        </div>
        <div v-if="eventData && eventData.length > 0" class="info-list">
          <a
            v-for="(item, i) in eventData"
            :key="i"
            :href="item.destUrl"
            @click="!item.destUrl && $event.preventDefault()"
            class="info-item"
            target="_blank"
          >
            <span class="info-link">{{ item.content }}</span>
            <i class="fa fa-external-link info-ext"></i>
          </a>
        </div>
        <div v-else-if="!eventData" class="text-center"><i class="fa fa-spinner fa-spin"></i></div>
        <div v-else class="info-empty">現在イベント情報はありません</div>
      </section>

      <section class="home-card info-card">
        <div class="section-header-row">
          <div class="section-heading"><i class="fa fa-book home-section-icon"></i><span class="section-title">マニュアル</span></div>
        </div>
        <div v-if="manualData && manualData.length > 0" class="info-list">
          <a
            v-for="(item, i) in manualData"
            :key="i"
            :href="item.destUrl"
            @click="!item.destUrl && $event.preventDefault()"
            class="info-item"
            target="_blank"
          >
            <span class="info-link">{{ item.content }}</span>
          </a>
        </div>
        <div v-else-if="!manualData" class="text-center"><i class="fa fa-spinner fa-spin"></i></div>
        <div v-else class="info-empty">現在マニュアルはありません</div>
      </section>
    </div>

    <!-- 5. Bottom Banner -->
    <div class="home-bottom-banners">
      <a
        v-for="(item, i) in bottomBanner"
        :key="i"
        class="bottom-banner-card"
        :href="item.destUrl"
        @click="!item.destUrl && $event.preventDefault()"
        target="_blank"
      >
        <img :src="item.content" class="bottom-banner-img">
      </a>
    </div>

    <modal-amazon-expiration v-if="isShowModalAmazonExpiration && amazonExpirationContext.length"
      :amazonExpirationContext="amazonExpirationContext"></modal-amazon-expiration>
  </div>
</template>

<script>
import Util, { replaceHTMLSellerInfo } from '@/common/utility'
import ModalAmazonExpiration from '@/components/ModalAmazonExpiration'
import TopBanner from '@/components/Slider'
import KpiSparkline from './components/KpiSparkline'
import HomeService from '@/services/homeservice'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAmazonExpiration,
    TopBanner,
    KpiSparkline
  },
  data () {
    return {
      isReady: false,
      loader: null,
      topBanner: [],
      amountsData: [],
      ordersData: [],
      salesData: [],
      returnsData: [],
      warehousesData: null,
      eventData: null,
      manualData: null,
      bottomBanner: []
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      notices: 'getNotices',
      analysisSubmenu: 'getAnalysisMenu',
      iconUrls: 'getWareHouseIcons'
    }),
    isShowModalAmazonExpiration () {
      let isShowModal = false
      if (this.userInfo.sellerId && localStorage.getItem('isShowModalAmazonExpiration')) {
        isShowModal = true
      }
      return isShowModal
    },
    amazonExpirationContext () {
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag === null) {
        return [
          { text: 'Amazon側のシステム変更により、', classes: '' },
          { text: '2022年12月31日までにAmazonとのデータ連携を設定して頂く必要があります。', classes: 'text-danger text--underline font-weight-normal' },
          { text: '実施頂けない場合、2023年1月以降にセールモンスターからの出品ができなくなります。', classes: 'mr-b-10' },
          { text: '※既にデータ連携が完了しているセラー様も、再度設定して頂く必要があります。', classes: 'text-danger text--underline mr-b-10 font-weight-normal' },
          { text: 'お手数おかけしますが、よろしくお願いいたします。', classes: 'mr-b-10' }
        ]
      }
      if (!this.userInfo.hasSpAccount || (this.userInfo.hasSpAccount && !this.userInfo.enableFlag)) {
        return [{ text: 'セールモンスターへ出品する場合は、Amazonとのデータ連携が必要です。', classes: '' }]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag && this.userInfo.expireAt === 1) {
        return [
          { text: '有効期限が近づいています。', classes: 'text-danger text--underline mr-b-10 font-weight-normal' },
          { text: '以下のボタンより再設定を行ってください。', classes: 'mr-b-10' }
        ]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag && this.userInfo.expireAt === 3) {
        return [
          { text: '有効期限が切れました。', classes: 'text-danger text--underline font-weight-normal' },
          { text: 'セールモンスターへ出品する場合は、再度Amazonとのデータ連携が必要です。', classes: 'mr-b-10' },
          { text: '以下のボタンより再設定を行ってください。', classes: 'mr-b-10' }
        ]
      }
      return []
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    },
    isPremiumTrial () {
      return this.userInfo.isPremiumTrial
    },
    plan () {
      return this.isBasicPlan ? 'ベーシック' : 'プレミアム'
    },
    warehouseScUsed () {
      return this.userInfo.scWarehouseUse === '1'
    },
    analysisId () {
      return this.analysisSubmenu.length > 0 ? this.analysisSubmenu[0].dispOrder : null
    },
    todayLabel () {
      if (!this.amountsData.length) return ''
      const parts = this.amountsData[0].orderDate.split('/')
      if (parts.length !== 3) return ''
      const [y, m, d] = parts.map(Number)
      const week = ['日', '月', '火', '水', '木', '金', '土']
      return `${y}年${m}月${d}日（${week[new Date(y, m - 1, d).getDay()]}）`
    },
    amountsRate () {
      if (!this.amountsData.length) return null
      return this.calcRate(this.amountsData[0].value, this.amountsData[1] ? this.amountsData[1].value : 0)
    },
    ordersRate () {
      if (!this.ordersData.length) return null
      return this.calcRate(this.ordersData[0].value, this.ordersData[1] ? this.ordersData[1].value : 0)
    },
    salesRate () {
      if (!this.salesData.length) return null
      return this.calcRate(this.salesData[0].value, this.salesData[1] ? this.salesData[1].value : 0)
    },
    returnsRate () {
      if (!this.returnsData.length) return null
      const rate = this.calcRate(this.returnsData[0].value, this.returnsData[1] ? this.returnsData[1].value : 0)
      return rate
    },
    listingUsageRatio () {
      if (!this.warehousesData) return 0
      return Math.min(100, Math.round((this.warehousesData.sale / this.warehousesData.maxListingAmount) * 100))
    }
  },
  async mounted () {
    let logParams = { name: eventCode.home.show, properties: {} }
    EventService.postTrackLog(logParams)
    await this.getTopBanner()
    this.getSalesData()
    this.getWarehousesData()
    this.getEventData()
    this.getManualData()
    this.getBottomBanner()
  },
  methods: {
    replaceHTMLSellerInfo,
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    calcRate (current, prev) {
      if (!prev) return null
      return Math.round((current - prev) / prev * 1000) / 10
    },
    async getTopBanner () {
      this.loader = this.$loading.show()
      await HomeService.getTopBanner()
        .then(response => { this.topBanner = response.data })
        .catch(err => { this.$store.commit('toggleModal', { show: true, message: err }) })
        .finally(() => { this.isReady = true; this.loader && this.loader.hide() })
    },
    getSalesData () {
      HomeService.getSalesData()
        .then(response => {
          this.amountsData = response.data.amounts
          this.ordersData = response.data.orders
          this.salesData = response.data.sales
          this.returnsData = response.data.returns
        })
        .catch(err => { this.$store.commit('toggleModal', { show: true, message: err }) })
    },
    getWarehousesData () {
      HomeService.getWarehousesData()
        .then(response => { this.warehousesData = response.data })
        .catch(err => { this.$store.commit('toggleModal', { show: true, message: err }) })
    },
    getEventData () {
      HomeService.getEventData()
        .then(response => { this.eventData = response.data })
        .catch(err => { this.$store.commit('toggleModal', { show: true, message: err }) })
    },
    getManualData () {
      HomeService.getManualData()
        .then(response => { this.manualData = response.data })
        .catch(err => { this.$store.commit('toggleModal', { show: true, message: err }) })
    },
    getBottomBanner () {
      HomeService.getBottomBanner()
        .then(response => { this.bottomBanner = response.data })
        .catch(err => { this.$store.commit('toggleModal', { show: true, message: err }) })
    },
    handleViewNotice (notice) {
      this.$router.push(`/Notices?scroll_to=${notice.id}`)
    },
    handleClickViewAnalysis () {
      if (this.analysisId) {
        this.$router.push({ name: 'Analysis', params: { id: this.analysisId } })
      }
    },
    handleClickJoinPremium () {
      this.$router.push('/setting/plan-info')
    },
    handleClickAddAvailableQuantity () {
      this.$router.push('/setting/service-info')
    },
    handleClickRequestReconsideration () {
      this.$router.push('/products-new/list')
    },
    handleClickGetStarted (type) {
      this.$router.push({ name: 'Warehouses', query: { name: type } })
    },
    handleClickOpenWarehouse (type) {
      if (type === 'salmonSc') {
        this.$router.push('/warehouse-sc/top')
      }
    }
  }
}
</script>

<style>
#home {
  .home-card {
    background: #fff;
    border: 1px solid #dce7ee;
    border-radius: 14px;
    box-shadow: 0 2px 10px rgba(36,71,99,0.08);
    padding: 20px 24px;
    margin-top: 16px;
  }

  /* ── Section headers ── */
  .section-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    gap: 14px;
  }

  .section-heading {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .section-heading-block {
    min-width: 0;
  }

  .home-section-icon {
    color: #1890d4;
    font-size: 16px;
  }

  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #1890d4;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .section-logo {
    width: 30px;
    height: 30px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .section-logo--sm {
    width: 26px;
    height: 26px;
  }

  .section-date {
    font-size: 12px;
    color: #8fa3b0;
    font-weight: normal;
  }

  .section-subtitle {
    font-size: 16px;
    color: #999;
    margin: 4px 0 0;
  }

  .section-link-btn {
    background: none;
    border: none;
    color: #1890d4;
    font-size: 13px;
    cursor: pointer;
    padding: 0;
    white-space: nowrap;
  }

  .btn-custom {
    border: 0;
    border-radius: 8px;
    font-weight: bold;
    font-size: 13px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    text-decoration: none;
    padding: 6px 14px;
    font-size: 12px;
    background: linear-gradient(#149fe7, #0b83d5);
    color: #fff;
  }

  .btn-premium-cta {
    border: 0;
    border-radius: 8px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 8px 14px;
    background: #F9DB76;
    color: #5a3d00;
  }

  /* ── 本日の販売状況 ── */
  .sales-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr) 1.6fr;
    gap: 14px;
    align-items: stretch;
  }

  .metric {
    border: 1px solid #e4ebef;
    border-radius: 12px;
    padding: 14px 14px 10px;
    min-height: 118px;
    min-width: 0;
  }

  .metric-top {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .metric-ico {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #66788a;
    flex-shrink: 0;
  }

  .metric-label {
    font-size: 18px;
    font-weight: bold;
    color: #456073;
  }

  .metric-value {
    font-size: 20px;
    font-weight: 900;
    color: #071b2c;
    margin-top: 2px;
    white-space: nowrap;
  }

  .metric-unit {
    font-size: 14px;
    font-weight: normal;
    margin-left: 2px;
    color: #6b7280;
  }

  .metric-note {
    font-size: 16px;
    color: #7d94a4;
    margin-top: 8px;
  }

  .note-up   { color: #16a34a; font-weight: bold; }
  .note-down { color: #ef4444; font-weight: bold; }
  .note-neutral { color: #9ca3af; font-weight: bold; }

  .sales-chart {
    border-left: 1px solid #e8eef2;
    padding-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }

  /* Sparkline styles (used by KpiSparkline component) */
  .kpi-sparkline-wrap {
    margin-top: 4px;
  }

  .sparkline-chart-area {
    position: relative;
    overflow: visible;
  }

  .sparkline-svg {
    width: 100%;
    height: 66px;
    display: block;
    overflow: visible;
  }

  .tt-date {
    font-size: 11px;
    font-weight: 700;
    color: #fff;
  }

  .tt-val {
    font-size: 11px;
    font-weight: 700;
    color: #fff;
  }

  .tt-extra {
    font-size: 10px;
    color: #d1d5db;
    margin-top: 2px;
  }

  .sparkline-x-labels-full {
    position: relative;
    height: 14px;
    margin-top: 3px;
  }

  .sparkline-x-labels-full span {
    position: absolute;
    transform: translateX(-50%);
    font-size: 12px;
    color: #9ca3af;
    white-space: nowrap;
    line-height: 1;
  }

  .sparkline-x-labels-full span.is-peak {
    color: #FF9800;
    font-weight: 600;
  }

  /* ── セルモンエージェントからのおすすめ ── */
  .agent-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    margin-top: 4px;
  }

  .agent-card {
    position: relative;
    border: 1px solid #e8edf2;
    border-radius: 14px;
    padding: 16px;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
  }

  .agent-card:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 4px;
  }

  .agent-card--red:before    { background: #ff7a59; }
  .agent-card--green:before  { background: #21b25e; }
  .agent-card--purple:before { background: #8d66ff; }
  .agent-card--blue:before   { background: #1c8ff1; }

  .agent-card--red    { background: linear-gradient(180deg, #fff8f5, #fff); }
  .agent-card--green  { background: linear-gradient(180deg, #f9fefb, #fff); }
  .agent-card--purple { background: linear-gradient(180deg, #fbf9ff, #fff); }
  .agent-card--blue   { background: linear-gradient(180deg, #f8fbff, #fff); }

  .agent-top {
    min-height: 20px;
  }

  .agent-tag {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 4px 10px;
    font-size: 18px;
    font-weight: bold;
    background: #f4f7f9;
    color: #6d8495;
  }

  .agent-tag--red    { background: #fff0eb; color: #ff7043; }
  .agent-tag--green  { background: #eaf7ee; color: #43a047; }
  .agent-tag--purple { background: #f0ebff; color: #7452e8; }
  .agent-tag--blue   { background: #e8f2fd; color: #1e88e5; }

  .agent-head {
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }

  .agent-icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
  }

  .agent-card--red .agent-icon    { background: #fff0ea; color: #ff633d; }
  .agent-card--green .agent-icon  { background: #e8f8ed; color: #14a24c; }
  .agent-card--purple .agent-icon { background: #f0ebff; color: #7452e8; }
  .agent-card--blue .agent-icon   { background: #e8f4ff; color: #1b86e5; }

  .agent-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.4;
    margin: 0;
    color: #1f2937;
  }

  .agent-value {
    font-size: 26px;
    font-weight: 900;
    line-height: 1;
    margin-top: 6px;
    color: #0b1f31;
  }

  .agent-card--red .agent-value    { color: #ff4d55; }
  .agent-card--green .agent-value  { color: #18a14d; }
  .agent-card--purple .agent-value { color: #6d4aea; }
  .agent-card--blue .agent-value   { color: #167fe0; }

  .agent-unit {
    font-size: 15px;
    font-weight: bold;
    margin-left: 3px;
  }

  .agent-caption {
    font-size: 14px;
    line-height: 1.6;
    color: #72899a;
    margin-top: auto;
  }

  .agent-premium-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    align-self: flex-start;
    margin-top: auto;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: bold;
    background: #F9DB76;
    color: #5a3d00;
  }

  .agent-btn {
    margin-top: auto;
    align-self: flex-start;
    padding: 8px 14px;
    font-size: 14px;
    border: 0;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .agent-btn--red    { background: #ff643e; color: #fff; }
  .agent-btn--green  { background: #e9fbef; color: #138d44; border: 1px solid #b8ebc8; }
  .agent-btn--purple { background: #f5f1ff; color: #7452e8; border: 1px solid #d8ccff; }
  .agent-btn--blue   { background: #eef7ff; color: #0d87d7; border: 1px solid #d6e9f8; }

  /* ── ご利用状況 ── */
  .usage-grid {
    display: grid;
    grid-template-columns: 1fr 1.2fr 1.35fr 1.45fr;
    gap: 14px;
    margin-top: 4px;
  }

  .usage-block {
    border: 1px solid #e6edf1;
    border-radius: 10px;
    padding: 14px 16px;
    min-height: 96px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    min-width: 0;
  }

  .usage-block--logi {
    justify-content: flex-start;
    gap: 8px;
  }

  .usage-block-head {
    font-size: 18px;
    font-weight: bold;
    color: #476174;
  }

  .usage-divider {
    height: 1px;
    background: #edf2f5;
  }

  .usage-stockcrew {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .stockcrew-logo {
    height: 26px;
    max-width: 100px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .usage-inline {
    display: flex;
    align-items: baseline;
    gap: 4px;
    flex-wrap: wrap;
  }

  .usage-inline-num {
    font-size: 22px;
    color: #0b1f31;
  }

  .usage-inline-num--sub {
    font-size: 18px;
  }

  .usage-inline-sep {
    color: #9aabb7;
    margin: 0 2px;
  }

  .usage-bar {
    height: 8px;
    border-radius: 999px;
    background: #e7eef1;
    overflow: hidden;
    margin-top: 2px;
  }

  .usage-bar-fill {
    display: block;
    height: 100%;
    background: #28b95f;
    border-radius: 999px;
  }

  .usage-status-row {
    display: flex;
    gap: 14px;
    align-items: baseline;
    flex-wrap: wrap;
    font-size: 16px;
    color: #000;
  }

  .usage-status-row span {
    white-space: nowrap;
  }

  .usage-label {
    font-size: 20px;
    color: #476174;
    font-weight: bold;
    white-space: nowrap;
  }

  .usage-value {
    font-size: 24px;
    font-weight: bold;
    color: #111827;
    white-space: nowrap;
  }

  .usage-unit {
    font-size: 14px;
    font-weight: normal;
    color: #6b7280;
  }
  .usage-status {
    font-size: 20px;
  }
  .usage-premium { color: #16a34a; }
  .usage-active  { color: #16a34a; }
  .usage-inactive { color: #9ca3af; }

  .usage-ng { color: #dc2626; }

  .usage-link {
    font-size: 14px;
    color: #1890d4;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    margin-top: auto;
  }

  /* ── お知らせ / イベント / マニュアル ── */
  .info-card {
    margin-top: 0;
  }

  .info-list {
    max-height: 260px;
    overflow-y: auto;
  }

  .info-item {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 9px 0;
    border-bottom: 1px dotted #dce7ee;
    font-size: 13px;
    color: #374151;
    text-decoration: none;
    cursor: pointer;
    line-height: 1.4;
  }

  .info-item:last-child {
    border-bottom: none;
  }

  .info-item:hover .info-link {
    color: #1890d4;
  }

  .info-date {
    color: #9ca3af;
    font-size: 11px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .info-link {
    color: #374151;
    min-width: 0;
  }

  .info-ext {
    font-size: 11px;
    color: #9ca3af;
    margin-left: auto;
    flex-shrink: 0;
  }

  .info-empty {
    font-size: 12px;
    color: #9ca3af;
    padding: 12px 0;
  }

  /* ── Responsive ── */
  @media (max-width: 1360px) {
    .agent-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .usage-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 992px) {
    .sales-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .sales-chart {
      grid-column: 1 / -1;
      border-left: 0;
      border-top: 1px solid #e8eef2;
      padding-left: 0;
      padding-top: 14px;
    }
    .usage-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 768px) {
    .home-card {
      padding: 16px;
    }
    .sales-grid {
      grid-template-columns: 1fr;
    }
    .agent-grid {
      grid-template-columns: 1fr;
    }
  }
}

/* ── お知らせ / イベント / マニュアル ── */
.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 16px;
}

@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

/* ── Bottom Banner ── */
.home-bottom-banners {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 16px;
}

.bottom-banner-card {
  display: block;
  overflow: hidden;
  border: 1px solid #e5edf1;
  box-shadow: 0 2px 10px rgba(36,71,99,0.08);
  line-height: 0;
}

.bottom-banner-img {
  width: 100%;
  display: block;
}

@media (max-width: 992px) {
  .home-bottom-banners {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .home-bottom-banners {
    grid-template-columns: 1fr;
  }
}

/* global: tooltip is position:fixed so it lives outside #home scope */
.kpi-sparkline-tooltip {
  position: fixed;
  transform: translate(-50%, calc(-100% - 10px));
  background: rgba(30, 30, 30, 0.9);
  color: #fff;
  padding: 4px 10px;
  border-radius: 5px;
  font-size: 10px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 9999;
  line-height: 1.5;
  text-align: left;
}

.kpi-sparkline-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: rgba(30, 30, 30, 0.9);
}
</style>



// WEBPACK FOOTER //
// src/view/home/Home.vue